import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import XOEasyMode from '../components/XOGame/XOEasyMode';
import XOMediumMode from '../components/XOGame/XOMediumMode';
import XOHardMode from '../components/XOGame/XOHardMode';

const XOGamePlay = () => {
    const location = useLocation();
    const [level, setLevel] = useState(null);
    useEffect(() => {
        setLevel(location?.state?.level);
    }, [location?.state]);
    console.log(level, 'l');
        switch (String(level)) {
            case "1":
                return <XOEasyMode />

            case "2":
                return <XOMediumMode />
            case "3":
                return <XOHardMode />
            default: return null
        }
}

export default XOGamePlay